const copyUrlBtns = document.querySelectorAll('.js-copy-url');
const container = document.querySelectorAll('.share-buttons');

function copyToClipboard(btn, index) {
  navigator.clipboard.writeText(window.location.href);
  container[index].classList.add('active');
  setTimeout(() => {
    container[index].classList.remove('active');
  }, 2000);
}

for (const [index, btn] of copyUrlBtns.entries()) {
  btn.addEventListener('click', (e) => {
    e.preventDefault()
    copyToClipboard(btn, index)
  })

  btn.addEventListener('keydown', function (event) {
      // Handle 'space' key
      if (event.which === 32) {
        event.preventDefault();
        copyToClipboard(btn, index)
      }
    }, false);
}

